import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { setBackground } from "../helpers/setBackground";
import { Footer } from "../Components/Footer";
import styles from "./styles.module.scss";

export const RegistrationPageDesktop = () => {
  useEffect(() => {
    setBackground();
  });

  return (
    <div id="login-page" className={styles.root}>
      <Outlet />
      <Footer />
    </div>
  );
};
